export default __webpack_public_path__ + "static/media/google-play.5abbc2c8.svg";